import { useCallback } from 'react';

import { useMultipleQueryParamStates } from './useMultipleQueryParamStates';

type Args = {
  name: string;
};

export function useQueryParamState({
  name,
}: Args): [string | undefined, (value: string | undefined) => void] {
  const [values, setValues] = useMultipleQueryParamStates({ names: [name] });

  const value = values[name];
  const setValue = useCallback(
    (newValue: string | undefined) => {
      setValues({ [name]: newValue });
    },
    [name, setValues],
  );

  return [value, setValue];
}
